import { reducer as commonReducer} from '../reducer';
import { ENABLE_TEMPORAL_MAX_RANGE, ENABLE_TEMPORAL_RANGE, LOAD_MASKS } from './action';

export function reducer(state=null, action) {
  const ret = commonReducer(state, action);
  if (ret != null) {
    return ret;
  }

  switch (action.type) {
  case ENABLE_TEMPORAL_RANGE:
    return {
      ...state,
      temporalRangeEnabled: action.enabled,
    };
  case ENABLE_TEMPORAL_MAX_RANGE:
    return {
      ...state,
      yearMaxRange: [action.start, action.end],
    };
  case LOAD_MASKS:
    const { masks } = action;
    return {
      ...state,
      masks,
    };
  default:
    return null;
  }
}
